import React, { useState, useCallback } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './contexts/AuthContext';
import Navigation from './components/Navigation';
import Sidebar from './components/Sidebar';
import VisaoGeral from './pages/VisaoGeral';
import EvoVendas from './pages/EvoVendas';
import ProtectedRoute from './components/ProtectedRoute';
import { clearCache } from './services/api';

function AppContent() {
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const [showFilters, setShowFilters] = useState(false);
  const [lastUpdate, setLastUpdate] = useState(new Date());

  // Função para atualizar o timestamp de última atualização
  const handleDataUpdate = useCallback(() => {
    setLastUpdate(new Date());
  }, []);

  // Função para forçar refresh dos dados - limpa cache e recarrega a página
  const handleRefresh = useCallback(async () => {
    // Limpar cache do frontend e backend
    await clearCache();
    // Recarregar a página para buscar dados frescos
    window.location.reload();
  }, []);

  return (
    <Router>
      <ProtectedRoute>
        <div className="min-h-screen flex flex-col">
          {/* Sidebar */}
          <Sidebar
            isOpen={sidebarOpen}
            onClose={() => setSidebarOpen(false)}
          />

          {/* Navigation com botão para abrir sidebar */}
          <Navigation
            onToggleSidebar={() => setSidebarOpen(!sidebarOpen)}
            isSidebarOpen={sidebarOpen}
            showFilters={showFilters}
            onToggleFilters={() => setShowFilters(!showFilters)}
            lastUpdate={lastUpdate}
            onRefresh={handleRefresh}
          />

          {/* Conteúdo principal */}
          <div className="pt-16 sm:px-4 md:px-14 pb-4 flex-1">
            <Routes>
              <Route
                path="/geral"
                element={
                  <VisaoGeral
                    showFilters={showFilters}
                    onDataUpdate={handleDataUpdate}
                  />
                }
              />
              <Route
                path="/vendas"
                element={
                  <EvoVendas
                    showFilters={showFilters}
                    onDataUpdate={handleDataUpdate}
                  />
                }
              />
              {/* Redireciona raiz para a aba principal */}
              <Route path="*" element={<Navigate to="/geral" replace />} />
            </Routes>
          </div>

          <footer className="bg-[#263238] min-h-[55px] sm:min-h-[64px] md:h-12 flex items-center px-3 sm:px-4 w-full select-none py-2 sm:py-0 mt-auto">
            <div className="flex flex-col sm:flex-row items-center w-full justify-between gap-2 sm:gap-0">
              {/* Logo + Texto central container */}
              <div className="flex items-center space-x-2 sm:space-x-3 min-w-0 pl-0 sm:pl-4 md:pl-12">
                <img
                  src="/Group.png"
                  alt="Grupo Mucuripe"
                  className="h-5 sm:h-6 md:h-7 w-auto brightness-0 invert flex-shrink-0"
                />
                <span className="text-white text-opacity-70 text-[10px] sm:text-[11px] md:text-[13px] truncate max-w-[120px] sm:max-w-xs md:max-w-2xl font-montserrat pl-2 sm:pl-4 hidden xs:inline">
                  Dashboards interativos para acompanhar as principais indicadores do Grupo Mucuripe
                </span>
              </div>
              {/* Copyright */}
              <span className="text-[#90A4AE] text-[9px] sm:text-[10px] md:text-[11px] whitespace-nowrap pr-0 sm:pr-4 md:pr-16">
                © {new Date().getFullYear()} Grupo Mucuripe. Todos os direitos reservados.
              </span>
            </div>
          </footer>
        </div>
      </ProtectedRoute>
    </Router>
  );
}

function App() {
  return (
    <AuthProvider>
      <AppContent />
    </AuthProvider>
  );
}

export default App;
